import { useForm } from 'react-hook-form';
import VyButton from '../../../../common/VyButton';
import { useTranslation } from 'next-i18next';
import VyTextField from '../../../../common/VyTextField';
import { HTMLComponentInterface } from '../../../../../interfaces/pagebuilder';
import { useSelector } from '../../../../../reduxToolkit/typedRedux';
import usePagebuilder from '../../../../../hooks/pagebuilder/usePagebuilder';
import { useEffect, useState } from 'react';
import { RegistrationField } from '../../../../../interfaces/interfaces';
import { Alert } from '@mui/material';

interface HTMLFallbackValuesSelectProps {
  component: HTMLComponentInterface;
  onChange: (data: HTMLComponentInterface['fallbackValues']) => void;
}

export default function HTMLFallbackValuesSelect({ onChange, component }: HTMLFallbackValuesSelectProps) {
  const registrationFields = useSelector((state) => state.common.registrationFields);

  const [filteredFields, setFilteredFields] = useState<RegistrationField[]>();

  const { t } = useTranslation();
  const { toTextVariable } = usePagebuilder();

  const usedVariables = [...new Set(component.content?.match(/{{\s*(.*?)\s*}}/g)?.map((match) => match.replace(/\{\{|\}/g, '')))];

  useEffect(() => {
    setFilteredFields(registrationFields.filter((registrationField) => usedVariables.includes(toTextVariable(registrationField.label))));
  }, [registrationFields]);

  return (
    <div className="flex flex-col gap-4 py-2">
      <Alert severity="info">{t('pagebuilder:fallback-values-description')}</Alert>
      {filteredFields?.map((field) => (
        <>
          <VyTextField
            label={field.label}
            defaultValue={component.fallbackValues?.find((fallback) => fallback.variable === toTextVariable(field.label))?.value}
            onBlur={(event) => onChange([{ variable: toTextVariable(field.label), value: event.target.value }])}
          />
        </>
      ))}
    </div>
  );
}
